import React from 'react';
import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface RouteDisclaimerProps {
  sx?: any;
}

export const RouteDisclaimer: React.FC<RouteDisclaimerProps> = ({ sx = {} }) => {
  return (
    <Box sx={{ mb: 0.5, textAlign: 'center', ...sx }}>
      <Link 
        component={RouterLink} 
        to="/ride-responsibly" 
        sx={{ 
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          color: 'info.main', 
          fontSize: '0.65rem',
          fontWeight: 400,
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline'
          }
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: '0.75rem' }} />
        Before You Go - check <Box component="span" sx={{ textDecoration: 'underline' }}>Ride Responsibly</Box>
      </Link>
    </Box>
  );
};
